import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import Icons from "scripts/icons";
import Resources from "scripts/resources";

const Component = () => {
	const [title, setTitle] = useState();
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const componentDidUpdate = () => {
		switch (pathname) {
			case "/about":
				setTitle(Resources.aboutUs);
				break;
			case "/faq":
				setTitle(Resources.faq);
				break;
			case "/contact":
				setTitle(Resources.contactUs);
				break;
			case "/support":
				setTitle(Resources.support);
				break;
			case "/terms":
				setTitle(Resources.terms);
				break;
			case "/panel/account":
				setTitle(Resources.account);
				break;
			case "/panel/bookmarks":
				setTitle(`${Resources.bookmark} ${Resources.ha}`);
				break;
			case "/panel/create":
				setTitle(`${Resources.add} ${Resources.job}`);
				break;
			case "/panel/jobs":
				setTitle(`${Resources.jobs} ${Resources.i}`);
				break;
			case "/panel/notifications":
				setTitle(Resources.notifications);
				break;
			case "/panel/transactions":
				setTitle(`${Resources.transaction} ${Resources.ha}`);
				break;
			case "/panel/wallet":
				setTitle(Resources.wallet);
				break;
			default:
				break;
		}
	};

	useEffect(componentDidUpdate, [pathname]);

	return title ? (
		<div className="pwa-header">
			<div className="container">
				<Icons.ArrowRight
					className="icon back"
					onClick={() => navigate(-1)}
				/>
				<h1 className="heading">{title}</h1>
			</div>
		</div>
	) : null;
};

export default Component;
